import React, { useState, useEffect } from "react";
import styled from "styled-components";
import {
  Time,
  formatTime,
  formatDistance,
  Pace,
} from "../../pace-fns/pace-fns";
import { usePreferences } from "../../usePreferences";
import { TimePicker } from "./TimePicker";

const PaceRow = styled.div`
    display: flex;
    flex-direction: row;
    min-height: ${({ isTimeSelected }: SplitProps) =>
      isTimeSelected ? "55px" : "45px"};
    border-radius: 8px;
    border: 1px solid #ffffff;
    box-shadow: 15px 15px 10px #f3f4ee, -15px -15px 10px #f7f8f2;
    overflow: hidden;
    border-radius: 8px;
    box-sizing: border-box;
`;

type SplitProps = {
  isTimeSelected: boolean;
};
const TimeContent = styled.div`
  padding: 13px 13px 13px 0px;
  min-height: ${({ isTimeSelected }: SplitProps) =>
    isTimeSelected ? "55px" : "44px"};
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: flex-end;
  background-color: #f9faf6;
  flex-grow: ${({ isTimeSelected }: SplitProps) =>
    isTimeSelected ? "3" : "1"};
`;

const StyledValue = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  height: 100%;
`;

const DistanceContent = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 44px;
  align-content: center;
  padding: 13px 0px 13px 13px;
  background-color: #fefffc;
  flex-grow: ${({ isTimeSelected }: SplitProps) =>
    isTimeSelected ? "1" : "3"};
  transition: all 0.3s;
`;

type Props = {
  pace: Pace;
  rowIndex: number;
  distanceDetailHandler: () => void;
  updateTimeHandler: (time: Pace) => void;
  style: any;
};

export const PaceTableRow = ({
  pace,
  distanceDetailHandler,
  updateTimeHandler,
  rowIndex,
  style,
}: Props) => {
  const [isTimeSelected, setIsTimeSelected] = useState(false);
  const [time, setTime] = useState(pace.time);
  const [preferences, _dispatch] = usePreferences();

  useEffect(() => {
    setTime(pace.time);
    setIsTimeSelected(false); // close the picker if its open, and the pace distance is decomposed
  }, [pace]);

  const handleDistanceSelection = () => {
    distanceDetailHandler();
  };
  const handleTimeSelection = () => {
    setIsTimeSelected(!isTimeSelected);
  };

  const onTimeSelection = (time: Time) => {
    setIsTimeSelected(false);
    setTime(time);
    updateTimeHandler({ ...pace, time });
  };

  return (
    <PaceRow isTimeSelected={isTimeSelected}style={{
      ...style,
      top: style.top + 25,
      height: style.height - 25
    }}>
      <DistanceContent
        theme={preferences.theme}
        onClick={handleDistanceSelection}
        isTimeSelected={isTimeSelected}
        data-tour-id={`distance-selector-${rowIndex}`}
      >
        <StyledValue>{formatDistance(pace.distance)}</StyledValue>
      </DistanceContent>
      <TimeContent
        theme={preferences.theme}
        onClick={handleTimeSelection}
        isTimeSelected={isTimeSelected}
        data-tour-id={`time-selector-${rowIndex}`}
      >
        {isTimeSelected ? (
          <TimePicker
            time={time}
            onSelectionFinish={onTimeSelection}
            closePicker={() => setIsTimeSelected(false)}
          />
        ) : (
          <StyledValue>{formatTime(time)}</StyledValue>
        )}
      </TimeContent>
    </PaceRow>
  );
};
